import React from "react";
import { View, Text } from "react-native";

const Logo = ({ size }) => {
  return (
    <View style={styles.container}>
      <View style={styles.textContainer}>
        <Text style={[styles.step, size && { fontSize: size }]}>Step</Text>
        <Text style={[styles.out, size && { fontSize: size }]}>Out</Text>
      </View>
    </View>
  );
};

const styles = {
  container: {
    justifyContent: "center",
    alignItems: "center",
    paddingVertiical: 10,
  },
  textContainer: {
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },
  step: {
    fontFamily: "Roboto",
    fontWeight: "500",
    color: "#474141",
    letterSpacing: 0.5,
    fontSize: 30,
  },
  out: {
    fontFamily: "Roboto",
    fontWeight: "300",
    color: "#474141",
    letterSpacing: 0.5,
    fontSize: 30,
  },
};

export default Logo;
